import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const FinancialYearList = Loadable(
  lazy(() => import("features/budget/financialYear/components/List"))
);
const FinancialYearPage = Loadable(
  lazy(() => import("features/budget/financialYear/components/Page"))
);

const FundList = Loadable(
  lazy(() => import("features/budget/fund/components/List"))
);
const FundPage = Loadable(
  lazy(() => import("features/budget/fund/components/Page"))
);

const BudgetList = Loadable(
  lazy(() => import("features/budget/budgetPlan/components/List"))
);
const BudgetPage = Loadable(
  lazy(() => import("features/budget/budgetPlan/components/Page"))
);

const FundAllocationList = Loadable(
  lazy(() => import("features/budget/fundAllocation/components/List"))
);

const IncomeSourceList = Loadable(
  lazy(() => import("features/budget/incomeSource/components/List"))
);
const IncomeSourcePage = Loadable(
  lazy(() => import("features/budget/incomeSource/components/Page"))
);

const IncomeTransactionList = Loadable(
  lazy(() => import("features/budget/incomeTransaction/components/List"))
);
const IncomeTransactionPage = Loadable(
  lazy(() => import("features/budget/incomeTransaction/components/Page"))
);

const PurchaseRecommendationList = Loadable(
  lazy(() => import("features/budget/purchaseRecommendation/components/List"))
);
const PurchaseRecommendationPage = Loadable(
  lazy(() => import("features/budget/purchaseRecommendation/components/Page"))
);

const PurchaseOrderList = Loadable(
  lazy(() => import("features/budget/purchaseOrder/components/List"))
);
const PurchaseOrderPage = Loadable(
  lazy(() => import("features/budget/purchaseOrder/components/Page"))
);

const InvoiceList = Loadable(
  lazy(() => import("features/budget/invoice/components/List"))
);
const InvoicePage = Loadable(
  lazy(() => import("features/budget/invoice/components/Page"))
);

const BudgetTransferList = Loadable(
  lazy(() => import("features/budget/budgetTransfer/components/List"))
);
const BudgetTransferPage = Loadable(
  lazy(() => import("features/budget/budgetTransfer/components/Page"))
);

const BudgetRevisionList = Loadable(
  lazy(() => import("features/budget/budgetRevision/components/List"))
);
const BudgetRevisionPage = Loadable(
  lazy(() => import("features/budget/budgetRevision/components/Page"))
);

const BudgetLedgerPage = Loadable(
  lazy(() => import("features/budget/budgetLedger/components/Page"))
);

const ExpenseCategoryList = Loadable(
  lazy(() => import("features/budget/expenseCategory/components/List"))
);
const ExpenseCategoryPage = Loadable(
  lazy(() => import("features/budget/expenseCategory/components/Page"))
);

const OtherExpenseList = Loadable(
  lazy(() => import("features/budget/otherExpense/components/List"))
);
const OtherExpensePage = Loadable(
  lazy(() => import("features/budget/otherExpense/components/Page"))
);

const routes = {
  path: "budget",
  children: [
    { path: "financial-year", element: <FinancialYearList /> },
    { path: "financial-year/add", element: <FinancialYearPage /> },
    {
      path: "financial-year/edit/:financialYearId?",
      element: <FinancialYearPage />,
    },

    { path: "fund", element: <FundList /> },
    { path: "fund/add", element: <FundPage /> },
    { path: "fund/edit/:fundId?", element: <FundPage /> },

    { path: "plan", element: <BudgetList /> },
    { path: "plan/add", element: <BudgetPage /> },
    { path: "plan/edit/:budgetId?", element: <BudgetPage /> },
    { path: "plan/:budgetId/allocations", element: <FundAllocationList /> },

    { path: "income-source", element: <IncomeSourceList /> },
    { path: "income-source/add", element: <IncomeSourcePage /> },
    {
      path: "income-source/edit/:incomeSourceId?",
      element: <IncomeSourcePage />,
    },

    { path: "income-transaction", element: <IncomeTransactionList /> },
    { path: "income-transaction/add", element: <IncomeTransactionPage /> },
    {
      path: "income-transaction/edit/:incomeTransactionId?",
      element: <IncomeTransactionPage />,
    },

    {
      path: "purchase-recommendation",
      element: <PurchaseRecommendationList />,
    },
    {
      path: "purchase-recommendation/add",
      element: <PurchaseRecommendationPage />,
    },
    {
      path: "purchase-recommendation/edit/:purchaseRecommendationId?",
      element: <PurchaseRecommendationPage />,
    },

    { path: "purchase-order", element: <PurchaseOrderList /> },
    { path: "purchase-order/add", element: <PurchaseOrderPage /> },
    {
      path: "purchase-order/edit/:purchaseOrderId?",
      element: <PurchaseOrderPage />,
    },

    { path: "invoice", element: <InvoiceList /> },
    { path: "invoice/add", element: <InvoicePage /> },
    { path: "invoice/edit/:invoiceId?", element: <InvoicePage /> },

    { path: "budget-transfer", element: <BudgetTransferList /> },
    { path: "budget-transfer/add", element: <BudgetTransferPage /> },
    {
      path: "budget-transfer/edit/:budgetTransferId?",
      element: <BudgetTransferPage />,
    },

    { path: "budget-revision", element: <BudgetRevisionList /> },
    { path: "budget-revision/add", element: <BudgetRevisionPage /> },
    {
      path: "budget-revision/edit/:budgetRevisionId?",
      element: <BudgetRevisionPage />,
    },

    { path: "budget-ledger", element: <BudgetLedgerPage /> },

    { path: "expense-category", element: <ExpenseCategoryList /> },
    { path: "expense-category/add", element: <ExpenseCategoryPage /> },
    {
      path: "expense-category/edit/:expenseCategoryId?",
      element: <ExpenseCategoryPage />,
    },

    { path: "other-expense", element: <OtherExpenseList /> },
    { path: "other-expense/add", element: <OtherExpensePage /> },
    {
      path: "other-expense/edit/:otherExpenseId?",
      element: <OtherExpensePage />,
    },
  ],
};

export default routes;
